<template>
    <div>
        <button class="tw-p-0 tw-text-inherit tw-bg-transparent tw-border-0" @click="displayPreferences = true; open = true">
            <slot></slot>
        </button>
        <div
            v-show="open"
            v-on:keydown.escape.prevent.stop="open = false"
            role="dialog"
            aria-label="Informace o cookies"
            class="tw-absolute sm:tw-fixed tw-inset-x-0 tw-top-0 sm:tw-top-auto sm:tw-bottom-0 sm:tw-p-8 sm:tw-max-h-screen sm:tw-overflow-y-auto tw-text-black tw-z-10"
        >
            <!-- Panel -->
            <div class="tw-prose tw-relative tw-max-w-xl tw-w-full tw-mx-auto tw-p-8 tw-bg-white tw-shadow-2xl sm:tw-rounded">

                <!-- General -->
                <div v-show="! displayPreferences">
                    <p>
                        Na stránce JOBS PEF používáme soubory cookies. Tyto soubory nám poskytují možnosti, jak lépe poskytovat služby a dále nám pomáhají analyzovat výkon webu. Informace o tom, jak naše weby používáte, můžeme sdílet se svými partnery působícími v oblasti sociálních médií, inzerce a analýz. V nastavení si můžete následně vybrat, které cookies můžeme používat. Svůj udělený souhlas, můžete kdykoliv změnit či odvolat.
                    </p>
                    <div class="tw-mt-8 tw-grid sm:tw-flex tw-gap-2">
                        <button type="button" @click="consentAll()" class="btn btn-primary">
                            Přijmout vše
                        </button>
                        <button type="button" @click="displayPreferences = true" class="btn tw-underline">
                            Nastavení
                        </button>
                    </div>
                </div>

                <!-- Preferenes -->
                <div v-show="displayPreferences" class="tw-space-y-8">
                    <h2 class="tw-mt-0 tw-text-xl tw-font-bold tw-text-primary">Nastavení pravidel pro Cookies</h2>
                    <p>
                        Na stránce JOBS PEF používáme soubory cookies. Tyto soubory nám poskytují možnosti, jak lépe poskytovat služby a dále nám pomáhají analyzovat výkon webu. Informace o tom, jak naše weby používáte, můžeme sdílet se svými partnery působícími v oblasti sociálních médií, inzerce a analýz.
                    </p>
                    <div>
                        <h3 class="tw-mb-0 tw-text-base tw-font-bold">Bezpodmínečně nutné soubory cookies</h3>
                        <label class="tw-flex tw-items-center tw-gap-4 sm:tw-gap-8">
                            <span>Tyto cookies jsou zásadní pro správnou funkčnost webu. Zajišťují správné zobrazení, odesílání formulářů a bez těchto cookies vám nemůžeme na našich webových stránkách poskytovat služby.</span>
                            <input type="checkbox" v-model="consent.technical" disabled>
                        </label>
                    </div>
                    <div>
                        <h3 class="tw-mb-0 tw-text-base tw-font-bold">Analytické a statistické cookies</h3>
                        <label class="tw-flex tw-items-center tw-gap-4 sm:tw-gap-8">
                            <span>Tento druh cookies používáme k vyhodnocování návštěvnosti a výkonu webových prezentací, např. kolik lidí dané prezentace navštěvuje, v jaké frekvenci, jaké informace hledáte, které naopak nenacházíte a které informace jsou nejdůležitější. Na základě těchto dat můžeme zlepšovat obsah a vylepšovat tak nabízené služby a informace.</span>
                            <input type="checkbox" v-model="consent.analytic">
                        </label>
                    </div>
                    <div>
                        <h3 class="tw-mb-0 tw-text-base tw-font-bold">Reklamní cookies</h3>
                        <label class="tw-flex tw-items-center tw-gap-4 sm:tw-gap-8">
                            <span>Reklamní cookies využívají naši partneři ke zobrazování relevantní reklamy na základě vašich preferencí.</span>
                            <input type="checkbox" v-model="consent.marketing">
                        </label>
                    </div>

                    <div class="tw-grid sm:tw-flex tw-gap-2">
                        <button type="button" @click="consentSelected()" class="btn btn-primary">
                            Povolit vybrané
                        </button>
                        <button type="button" @click="open = false" class="btn tw-underline">
                            Zavřít
                        </button>
                    </div>

                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            consent: {
                technical: true,
                analytic: false,
                marketing: false,
            },
            open: true,
            displayPreferences: false
        }
    },

    methods: {
        init() {
            let cc = window.localStorage.getItem('cc');
            this.open = cc == null;
            if (cc) {
                this.consent = JSON.parse(window.localStorage.getItem('cc'));
                this.emit();
            }
        },

        storeConsent() {
            window.localStorage.setItem('cc', JSON.stringify(this.consent));
            this.emit();
            this.open = false;
        },

        consentAll() {
            this.consent = {
                technical: true,
                analytic: true,
                marketing: true
            };
            this.storeConsent();
        },

        consentRequired() {
            this.consent = {
                technical: true,
                analytic: false,
                marketing: false
            };
            this.storeConsent();
        },

        consentSelected() {
            this.storeConsent();
        },

        emit() {
            if (this.consent.analytic) {
                console.log('cc-analytic');
                window.dataLayer && window.dataLayer.push({ event: 'cc-analytic'});
            };
            if (this.consent.marketing) {
                console.log('cc-marketing');
                window.dataLayer && window.dataLayer.push({ event: 'cc-marketing'});
            };
        }
    },

    mounted() {
        this.init();
    }
}
</script>
